module.exports = __webpack_public_path__ + "media/t_bpair.911c6bc1.mp3";